import parse from 'url-parse'
import logger from '@/assets/log'
import router from '@/router';
const log = logger("model:login");

export default {
    getToken() {
        let q = parse(location.href, true);
        let token = q.query["token"];

        return token;
    },
    toLoginPage(url, platformCode, sid) {
        let q = parse(url, true);
        if (q) {
            q.query.url = encodeURIComponent(location.href);
            q.query.platformCode = platformCode;
            q.query.sid = sid;

            log("跳到登陆页: %o", q)
            location.href = q.toString();
        }
    },
    toLogoutPage(url) {

        let q = parse(url, true);
        if (q) {
            q.query.url = encodeURIComponent(location.href);

            log("跳到注销页: %o", q)
            location.href = q.toString();
        }
    },
    onLogin() {
        if (this.getToken()) {
            //去掉token 参数

            let q = parse(location.href, true);
            delete q.query.token;

            if (history.replaceState) {
                // 使用H5 api减少一次跳转
                log("使用history.replaceState: %o", q)
                history.replaceState({}, "", q.toString())
                router.push('/home')
                return true;
            } else {
                log("location.replace: %o", q)
                location.replace(q.toString());
                return false;
            }
        }

        return true;
    },
    onLogout() {
        location.reload()
    }
}